<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <checkbox-container>
            <pr-input-checkbox
              [derrors]="derrors"
              formControlName="receivePreContractElementsEmail"
              label="Recevoir par mail les éléments pré-contractuels
                  (DIC du contrat, DIS des supports, annexes financières, DER, lettre de mission .... ) "
            >
            </pr-input-checkbox>
          </checkbox-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <div class="sticky">
    <div class="btn-group">
      <pr-button
        size="lg"
        type="button"
        display="neutral"
        label="Question suivante"
        (onClick)="submit()"
      ></pr-button>
      @if (sessionConsultant) {
        <pr-icon
          (click)="notifyClick()"
          class="right-icon forward ng-star-inserted"
          _nghost-fxs-c169=""
        >
          <i class="fa fa-solid fa-forward"></i>
        </pr-icon>
      }
    </div>
  </div>
</form>
